import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import {
  ID_VERSE_MOBILE_POLLING_TIMEOUT_MS,
  ID_VERSE_MOBILE_SYNCING_DELAY_THRESHOLD_MS,
  ID_VERSE_MOBILE_SYNCING_TIMER_INTERVAL_MS,
} from '../../local-domain/models/id-verse-content.data';

@Component({
  selector: 'ifc-id-verse-mobile-syncing-section',
  templateUrl: './id-verse-mobile-syncing-section.component.html',
  styleUrls: ['./id-verse-mobile-syncing-section.component.scss'],
  standalone: false
})
export class IdVerseMobileSyncingSectionComponent implements OnInit, OnDestroy {
  readonly SyncingState = SyncingState;
  syncingState = SyncingState.TimedOut;
  private timerSubscription: Subscription;

  ngOnInit(): void {
    const startedAt = Date.now();

    this.timerSubscription = interval(ID_VERSE_MOBILE_SYNCING_TIMER_INTERVAL_MS)
      .pipe(startWith(0))
      .subscribe(() => {
        const elapsedMs = Date.now() - startedAt;

        if (elapsedMs >= ID_VERSE_MOBILE_POLLING_TIMEOUT_MS) {
          this.syncingState = SyncingState.TimedOut;
          return;
        }

        if (elapsedMs >= ID_VERSE_MOBILE_SYNCING_DELAY_THRESHOLD_MS) {
          this.syncingState = SyncingState.Delayed;
          return;
        }

        this.syncingState = SyncingState.Initial;
      });
  }

  ngOnDestroy(): void {
    if (!this.timerSubscription) {
      return;
    }

    this.timerSubscription.unsubscribe();
    this.timerSubscription = null;
  }
}

enum SyncingState {
  Initial = 'initial',
  Delayed = 'delayed',
  TimedOut = 'timed-out',
}